<template>
  <div class="content-wrapper">
    <img src="https://oss.aqdpay.com/appweb/baying/by.png" alt="">
    <div class="title margin-top">
      <div>姓名</div>
      <div>{{realName}}</div>
    </div>
    <div class="line"/>
    <div class="title">
      <div>手机号</div>
      <div>{{mobile}}</div>
    </div>
    <div class="line"/>
    <div class="title">
      <div>身份证</div>
      <div>{{idNo}}</div>
    </div>
    <div class="btn">
      <div class="btn-left" @click="handleUnAuth">暂不授权</div>
      <div class="btn-right" @click="handleAuth">确认授权</div>
    </div>

    <div v-if="!showLoading" class="input-box-tip">
      <img v-if="!isAgree" class="agree-img" src="~@/assets/images/unselected.png" @click="handleAgreeSelectedBtn">
      <img v-if="isAgree" class="agree-img" src="~@/assets/images/selected.png" @click="handleAgreeSelectedBtn">
      <div class="agree-text" @click="handleXieYi">阅读并同意《用户授权协议》</div>
    </div>
    <img v-if="showLoading" class="loading-img" src="~@/assets/images/auth/loading.png" alt="">
  </div>
</template>

<script>
import { setStore } from '@/utils'
import { checkBaiYangAuthorize, baiYangAuthorize } from '@/api/active'
import { Toast } from 'vant'
export default {
  data () {
    return {
      idNo: '',
      realName: '',
      url: '',
      mobile: '',
      showLoading: true,
      isAgree: false
    }
  },
  mounted () {
    const token = this.$route.query.accessToken
    if (token) {
      setStore('token', token)
      this.check()
    } else {
      this.goLogin()
    }
  },
  methods: {
    goLogin () {
      /* eslint-disable */
      dsBridge.call('callLogin',function(res) {
        const token = res
        if (res) {
          setStore('token', token)
        }
      })
    },
    handleAuth (){
      if(!this.isAgree){
        Toast({
          message: '请同意用户协议'
        })
        return
      }
      baiYangAuthorize({}).then(res => {
        if (res && res.data) {
          const datas = res.data.result
          this.idNo = datas.idNo
          this.realName = datas.realName
          this.url = datas.url
          this.mobile = datas.mobile
          if(datas.authFlag == 1){
            window.location.href = datas.url
          }
        }
      })
    },
    handleUnAuth (){
      /* eslint-disable */
      dsBridge.call('callCloseCurView', {})
    },
    handleAgreeSelectedBtn () {
      this.isAgree = !this.isAgree
    },
    handleXieYi () {
      window.open('https://bjweb.aqdpay.com/appweb/policyTemplate?id=c5d2c76bf34b3fbec88ed3169ecda427', '_blank');
    },
    check () {
      checkBaiYangAuthorize({}).then(res => {
        if (res && res.data) {
          const datas = res.data.result
          this.idNo = datas.idNo
          this.realName = datas.realName
          this.url = datas.url
          this.mobile = datas.mobile
          if(datas.authFlag == 1){
            window.location.href = datas.url
          }else {
            this.showLoading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  min-height: 100vh;
  height: 100%;
  width: 100%;
  position: relative;
  overflow-x: hidden;
  background-color: #F8F8F8;
  img {
    display: block;
    width: 100%;
  }
  .loading-img {
    position: absolute;
    top: 0;
    width: 100%;
  }
  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    padding: 4.5vw 4vw 4.5vw 4vw;
    font-size: 4vw;
    color: #282828;
  }
  .line {
    margin-left: 4vw;
    width: 100%;
    height: 1px;
    background-color: #F1F1F1;
  }
  .margin-top {
    margin-top: 3.75vw;
  }
  .btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 7.2vw 13.6vw 0px 13.6vw;
    .btn-left {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 33vw;
      height: 10.6vw;
      background: #FFFFFF;
      border: 1px solid #4F7DFF;
      border-radius: 10.6vw;
      font-weight: 400;
      font-size: 4vw;
      color: #4F7DFF;
      text-align: center;
    }
    .btn-right {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 33vw;
      height: 10.6vw;
      background: #4F7DFF;
      border-radius: 10.6vw;
      font-weight: 400;
      font-size: 4vw;
      color: #FFFFFF;
      text-align: center;
    }
  }
  .input-box-tip {
    position: absolute;
    bottom: 4.3vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    .un-agree {
      height: 3.2vw;
      width: 3.2vw;
      background: #FFFFFF;
      border: 1px solid #C1C1C1;
    }
    .agree-img {
      height: 3.2vw;
      width: 3.2vw;
    }
    .agree-text {
      margin-left: 2.1vw;
      font-size: 3.2vw;
      color: #008AFF;
    }
  }
}
</style>
